export default "__VITE_ASSET__DLWc9m4w__"